<template>
  <a-modal
    :visible.sync="tipDialogVisible"
    width="760px"
    :title="$t('message[1819]')"
    class="tv-range-data-dialog"
    :mask-closable="false"
    :ok-text="$t('message[915]')"
    :cancel-text="$t('message[896]')"
    @cancel="tipDialogVisible = false"
    @ok="formHandle"
  >
    <div class="alert-blue-title">
      {{ $t('message[1820]') }}
    </div>
    <div class="content clearfix">
      <div class="left fl">
        <h3>{{ $t('message[1821]') }}</h3>
        <div
          v-if="currentRangeDatas.length"
          class="result scroll_bar_beautify_ff"
        >
          <a-tree
            v-if="currentRangeDatas.length"
            ref="treeList"
            checkable
            :default-expanded-keys="checkedKeys"
            :tree-data="currentRangeDatas"
            :checked-keys="checkedKeys"
            :show-checked-strategy="true"
            @check="onCheck"
          />
        </div>
      </div>
      <span class="border" />
      <div class="right fl">
        <h3>{{ $t('message[1822]') }}</h3>
        <div
          v-for="(item, i) in checkedDatas"
          :key="i"
          class="item clearfix"
        >
          <div class="fl">
            <span>{{ item.name }}</span>
          </div>
          <i
            class="iconfont iconicon-test5 fr close-icon"
            @click="onDeleteItem(item, i)"
          />
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    /* 已选择的人员数据 */
    datas: {
      type: Array,
      default () {
        return []
      }
    },
    /* 左侧的选项 - 所有人员数据 */
    currentRangeDatas: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tipDialogVisible: false,
      submiting: false,
      checkedKeys: [], // 已选择的key值数组
      checkedDatas: [] // 已选择的key和name数组
    }
  },
  watch: {
    // 监听树形数据选中数据，设置右边选中元素集合
    checkedKeys (val) {
      this.checkedDatas = []
      val.forEach(item => {
        this.checkedDatas = this.filterCheckedKeys(this.checkedDatas, item, val, this.currentRangeDatas)
      })
    },
    tipDialogVisible (val) {
      if (val) {
        this.checkedDatas = this.datas
        this.getCheckedKeys()
      }
    }
  },
  methods: {
    toggleDialog (b) {
      this.tipDialogVisible = b
    },
    formHandle () {
      this.$emit('confirm', this.checkedDatas)
      this.tipDialogVisible = false
    },
    onCheck (val, info) {
      this.checkedKeys = val
    },
    // 递归过滤已选中父元素的子元素
    filterCheckedKeys (arr, i, checkedKeys, data) {
      data.forEach(item => {
        const isHasChildren = item.children && item.children.length
        if (item.key === i && !checkedKeys.includes(item.pid) && !arr.find(o => item.key === o.key)) {
          arr.push({ key: item.key, name: item.title })
        } else if (isHasChildren) {
          this.filterCheckedKeys(arr, i, checkedKeys, item.children)
        }
      })
      return arr
    },
    // 删除后数据处理
    onDeleteItem (item, i) {
      this.checkedDatas.splice(i, 1)
      this.getCheckedKeys()
    },

    // 获取树形结构选中值方法
    getCheckedKeys () {
      this.checkedKeys = []
      this.checkedDatas.forEach(item => {
        this.checkedKeys = this.checkedKeysLoop(this.checkedKeys, item.key, this.currentRangeDatas)
      })
    },

    // 获取树形结构选中值递归
    checkedKeysLoop (arr, key, treeDatas) {
      treeDatas.forEach(item => {
        const isHasChildren = item.children && item.children.length
        if (item.key === key) {
          arr.push(item.key)
          if (isHasChildren) {
            item.children.forEach(item2 => {
              arr.push(item2.key)
              if (item2.children && item2.children.length) {
                item2.children.forEach(item3 => {
                  arr.push(item3.key)
                })
              }
            })
          }
        } else {
          if (isHasChildren) {
            this.checkedKeysLoop(arr, key, item.children)
          }
        }
      })
      return arr
    }

  }
}
</script>
<style lang="scss">
.tv-range-data-dialog {
  .ant-modal {
    padding-bottom: 0;
  }
  .ant-modal-body {
    padding: 16px 40px;
  }
  .ant-tree li span.ant-tree-switcher {
    color: #ccc;
  }
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-select-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-select-switcher-icon {
    font-size: 24px;
    color: #d8d8d8;
  }
  .ant-tree > li {
    > .ant-tree-node-content-wrapper {
      .ant-tree-title {
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.alert-blue-title {
  background-color: #e8f4ff;
  color: #333;
  font-size: 14px;
  line-height: 24px;
  padding: 8px 24px;
  margin: -16px -40px 4px;
}
.content {
  position: relative;
  padding-top: 12px;
  h3 {
    height: 48px;
    line-height: 48px;
    font-weight: bold;
  }
  .left {
    width: 320px;
    margin-right: 40px;
    .result {
      max-height: 524px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .border {
    position: absolute;
    left: 320px;
    top: 0;
    width: 0;
    height: 100%;
    border-right: solid 1px $gray4;
  }
  .right {
    width: 320px;
    .result {
      max-height: 524px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .item {
      overflow: hidden;
      height: 32px;
      line-height: 32px;
      padding: 0 12px;
    }
    .iconfont.close-icon {
      margin-right: 20px;
      cursor: pointer;
      color: #d6d6d6;
    }
  }
}
.footer {
  text-align: right;
}
</style>
